import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../utils/focusContainer.js';
import { opacityDisabled } from '../../utils/opacityDisabled.js';

const StyledButtonIcon = styled.button(({ variation = 'primary', disabled, theme: { olist: { components: { button }, }, }, }) => css `
    border-radius: ${button.icon.radius};
    border: none;
    cursor: pointer;
    height: ${button.icon.size.height};
    width: ${button.icon.size.width};
    display: inline-flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;

    background-color: ${button.icon.styles[variation].rest['background-color']};
    color: ${button.icon.styles[variation].rest.color};

    ${disabled
    ? opacityDisabled
    : css `
          &:hover {
            background-color: ${button.icon.styles[variation].hover['background-color']};
            color: ${button.icon.styles[variation].hover.color};
          }

          &:active {
            background-color: ${button.icon.styles[variation].active['background-color']};
            color: ${button.icon.styles[variation].active.color};
          }

          ${focusContainer() ``}
        `}

    transition: 400ms ease;
    ${margins}
  `);

export { StyledButtonIcon };
